import * as React from 'react';
// mui
import {
  Box,
  Typography,
  Container,
} from '@mui/material';
// icons
import CelebrationIcon from '@mui/icons-material/Celebration';

export default function NoTask() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      minHeight="70vh"
    >
      <Container
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Box width="100%">
          <Typography textAlign="center"><CelebrationIcon color="primary" fontSize="large"/></Typography>
          <Typography variant="h6" textAlign="center">No Task To Do!</Typography>
          <Typography variant="body1" textAlign="center">Enjoy your free time! So many options, how about enjoying a hot chocolate?</Typography>
        </Box>
      </Container>
    </Box>
  );
}
